<div class="flex min-h-screen items-center justify-center p-2">
  <div
    class="my-6 max-w-md overflow-hidden rounded-xl border border-gray-100 bg-white shadow-md transition-colors duration-200 dark:border-gray-800 dark:bg-gray-900"
  >
    <div class="p-6 text-center">
      <div
        class="mb-4 inline-flex h-24 w-24 items-center justify-center rounded-full bg-emerald-50 text-emerald-600 dark:bg-emerald-950/40 dark:text-emerald-400"
      >
        <mat-icon class="scale-300!">check_circle</mat-icon>
      </div>

      <h2 class="mb-2 text-xl font-bold text-gray-800 dark:text-gray-100">
        ¿Confirmar su participación en el proceso de contratación?
      </h2>
      <p class="mb-6 text-sm text-gray-500 dark:text-gray-400">
        Al hacer clic en el botón, confirmará su participación en el proceso de contratación.
      </p>

      <button matButton="filled" (click)="aceptarHabilitacion()">
        <mat-icon>check_circle</mat-icon>
        Confirmar ahora
      </button>
    </div>
  </div>
</div>
